const initialState = { networkCalls: 0 };

export const actions = {
  LOAD: 'loader/load',
  SUCCESS: 'loader/success',
  FAILURE: 'loader/failure',
};

export const load = () => {
  return {
    type: actions.LOAD,
  };
};

export const success = () => {
  return {
    type: actions.SUCCESS,
  };
};

export const failure = () => {
  return {
    type: actions.FAILURE,
  };
};

export const loadLitmosReducer = (
  state = initialState,
  action: { type: string }
) => {
  const { type } = action;
  const matches = /(.*)\/(LOAD|SUCCESS|FAILURE)$/i.exec(type);

  // not a */REQUEST / */SUCCESS /  */FAILURE actions, so we ignore them
  if (!matches) return state;

  const [, requestName, requestState] = matches;
  const isLoad = requestState === 'load';
  const callValue = isLoad ? 1 : -1;
  return {
    ...state,
    // Store the request that is occurring
    // and increase/decrease the network calls
    [requestName]: requestState === 'load',
    networkCalls: state.networkCalls + callValue,
  };
};
